import { createSvgIcon } from "@mui/material";

export const GreenCheckIcon = createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12286_43925)">
      <path
        d="M7.34712 8.83493C6.96561 8.45508 6.39311 8.45508 6.01116 8.83493C5.6292 9.21478 5.62964 9.78478 6.01116 10.1651L8.87361 13.015C9.06459 13.2052 9.25512 13.3 9.54137 13.3C9.82761 13.3 10.0186 13.2052 10.2091 13.015L16.888 5.41496C17.1743 4.93981 17.1743 4.36982 16.6971 4.08482C16.3155 3.79982 15.7431 3.79982 15.4568 4.17967L9.54092 10.9248L7.34622 8.83493H7.34712Z"
        fill="#2CAF2C"
      />
      <path
        d="M18.1287 8.54993C17.5562 8.54993 17.1747 8.92978 17.1747 9.49978C17.1747 13.6799 13.7398 17.0999 9.54137 17.0999C5.34295 17.0999 1.90845 13.6799 1.90845 9.49978C1.90845 7.50479 2.67192 5.60466 4.10315 4.17967C5.53438 2.65983 7.44283 1.89969 9.54182 1.89969C10.1143 1.89969 10.7821 1.99454 11.3546 2.08984C11.8318 2.27998 12.4043 1.99498 12.5948 1.42499C12.7853 0.854993 12.4038 0.475145 11.9271 0.284998H11.8318C11.0683 0.0948508 10.3053 0 9.54182 0C4.29368 0 0 4.27497 0 9.59507C0 12.0652 1.04972 14.5349 2.76719 16.2449C4.57993 18.0497 6.96561 19 9.44611 19C14.6938 19 18.9875 14.725 18.9875 9.50022C19.0827 8.93023 18.606 8.55038 18.1287 8.55038V8.54993Z"
        fill="#2CAF2C"
      />
    </g>
  </svg>,
  "Green Check"
);
